import { combineReducers } from "redux";

import app from "reducers/app.reducer";
import auth from "reducers/auth.reducer";
import designationsList from "reducers/designations.reducer";
import employeePersonalDetails from "reducers/employeepersonaldetails.reducer";
import employeeProfDetails from "reducers/employeeprofessionaldetails.reducer";
import employees from "reducers/employees.reducer";
import entitiesList from "reducers/entities.reducer";
import locationsList from "reducers/locations.reducer";
import projects from "reducers/projects.reducer";
import skills from "reducers/skills.reducer";
import subprojects from "reducers/subprojects.reducer";
import worktypes from "reducers/worktypes.reducer";
import modulesList from "reducers/modules.reducer";
import jobsList from "reducers/joblists.reducer";
import jobcountdetails from "reducers/jobcounts.reducer";
import scheduledetails from "reducers/schedule.reducer";

import leaves from "reducers/leave.reducer";
import teams from "reducers/teamlist.reducer";

import jobdetails from "reducers/jobdetails.reducer";

import employeeskills from "reducers/employeeskilldetails.reducer";
import userdetailsforjob from "reducers/userdetailsforjob.reducer";
import jobsocketdetails from "reducers/jobsocketdetails.reducer";
import routesList from "reducers/routeslist.reducer";
import createRouteInfo from "reducers/createroute.reducer";
import stopsList from "reducers/stopslist.reducer";
import updateRouteInfo from "reducers/updateroute.reducer";
import vehiclesList from "reducers/vehiclesList.reducer";

import createVehicleInfo from "reducers/addvehicleinfo.reducer";
import createLocationInfo from "reducers/addstop.reducer";

import slotsList from "reducers/slotslist.reducer";
import addbooking from "reducers/addbooking.reducer";

import bookingsList from "reducers/fetchbookings.reducer";
import employeebookingsList from "reducers/employee_bookings_list.reducer";
import driversList from "reducers/driversList.reducer";
import confirmBooking from "reducers/confirmbooking.reducer";

import events from "reducers/eventlist.reducer";
import event from "reducers/event.reducer";
import eventgroups from "reducers/eventgroups.reducer";
import vehiclessummary from "reducers/vehiclessummary.reducer";
import passengersList from "reducers/passengersList.reducer";
import tripanalytics from "reducers/tripanalytics.reducer";

import taskmanagementdetails from "reducers/taskmanagement.reducer";

import deletevehicle from "reducers/deletevehicle.reducer";
import projectManagement from "reducers/projectmanagement.reducer";

import goals from "reducers/goals.reducer";

import deleteUser from "reducers/deleteAccount.reducer";
import filterReducer from "reducers/filter.reducer";
import employeeManagement from "reducers/employee.management.reducer";
import jobSchedule from "reducers/jobSchedule.reducer";
import signup from "reducers/signup.reducer";
import chat from "reducers/chat.reducer";
import rooms from "reducers/rooms.reducer";
import competency from "reducers/competency.reducer";


const reducers = combineReducers({
  app,
  auth,
  designationsList,
  employeePersonalDetails,
  employeeProfDetails,
  employees,
  entitiesList,
  locationsList,
  projects,
  skills,
  subprojects,
  worktypes,
  modulesList,
  leaves,
  teams,
  jobsList,
  jobcountdetails,
  jobdetails,
  employeeskills,
  userdetailsforjob,
  jobsocketdetails,
  routesList,
  createRouteInfo,
  stopsList,
  updateRouteInfo,
  vehiclesList,
  createVehicleInfo,
  slotsList,
  addbooking,
  bookingsList,
  employeebookingsList,
  driversList,
  confirmBooking,
  events,
  event,
  eventgroups,
  vehiclessummary,
  passengersList,
  tripanalytics,
  createLocationInfo,
  scheduledetails,
  taskmanagementdetails,
  deletevehicle,
  projectManagement,
  goals,
  deleteUser,
  filterReducer,
  employeeManagement,
  jobSchedule,
  signup,
  chat,
  rooms,
  competency,
});

export default reducers;
